import {Component, HostListener, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {CoverArt} from '../../../services/data.model';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-coverart-list',
  templateUrl: './coverart-list.component.html',
  styleUrls: ['./coverart-list.component.scss']
})
export class CoverArtListComponent implements OnInit {

  coverArts: CoverArt[];

  constructor(private http: HttpClient) {
  }

  public coverArtUrl(path: string) {
    return 'url(\'' + path + '\')';
  }

  public ngOnInit(): void {
      this.http.get(
        environment.cmsUrl + environment.routes.listCoverArts
      ).subscribe((data: CoverArt[]) => {
          this.coverArts = data.filter(a => a.is_artwork);
      });
  }
}
